import { render, staticRenderFns } from "./b2b-select.vue?vue&type=template&id=6626a960"
import script from "./b2b-select.vue?vue&type=script&lang=js"
export * from "./b2b-select.vue?vue&type=script&lang=js"
import style0 from "./b2b-select.vue?vue&type=style&index=0&id=6626a960&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports